module.exports = __webpack_public_path__ + "img/support_d1.fd7410da.png";